import { useEffect } from "react";

const SKIP = "input, textarea, select, [contenteditable=''], [contenteditable='true'], [role='slider'], [data-no-drag]";

function scroller(node) {
  for (let el = node; el && el !== document.body; el = el.parentElement) {
    if (el.scrollWidth - el.clientWidth <= 4) continue;
    const ox = getComputedStyle(el).overflowX;
    if (ox === "auto" || ox === "scroll") return el;
  }
  return null;
}

/* Site-wide click-and-drag for horizontal scrollers (mouse only; touch keeps native swipe). */
export function useDragScroll() {
  useEffect(() => {
    let drag = null;
    const swallowClick = (e) => { e.stopImmediatePropagation(); e.preventDefault(); };

    const onDown = (e) => {
      if (e.pointerType !== "mouse" || e.button !== 0 || e.target.closest(SKIP)) return;
      const el = scroller(e.target);
      if (!el) return;
      drag = { el, x: e.clientX, left: el.scrollLeft, moved: false, prev: { behavior: el.style.scrollBehavior, snap: el.style.scrollSnapType } };
      el.style.scrollBehavior = "auto";
    };
    const onMove = (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        drag.el.style.scrollSnapType = "none";
        drag.el.setAttribute("data-hdrag", "on");
        document.body.classList.add("hdragging");
      }
      drag.el.scrollLeft = drag.left - dx;
    };
    const onUp = () => {
      if (!drag) return;
      const { el, prev, moved } = drag;
      el.style.scrollBehavior = prev.behavior; el.style.scrollSnapType = prev.snap;
      el.setAttribute("data-hdrag", "");
      document.body.classList.remove("hdragging");
      if (moved) {
        document.addEventListener("click", swallowClick, true);
        setTimeout(() => document.removeEventListener("click", swallowClick, true), 0);
      }
      drag = null;
    };
    const onDragStart = (e) => { if (drag) e.preventDefault(); };
    const onOver = (e) => {
      if (e.target.closest("[data-hdrag]")) return;
      const el = scroller(e.target);
      if (el) el.setAttribute("data-hdrag", "");
    };

    document.addEventListener("pointerdown", onDown);
    document.addEventListener("pointermove", onMove);
    document.addEventListener("pointerup", onUp);
    document.addEventListener("pointercancel", onUp);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("dragstart", onDragStart);
    return () => {
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      document.removeEventListener("pointercancel", onUp);
      document.removeEventListener("mouseover", onOver);
    };
  }, []);
}

export function DragScroll() { useDragScroll(); return null; }
